// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jg_a bht_a bht_j bht_q bht_sv bht_sw bht_w"};